import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=65e32236"
import script from "./FormList.js?vue&type=script&lang=js&external"
export * from "./FormList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports